


















import Vue from 'vue';
import { VTabs } from 'vuetify/lib';

export default Vue.extend({
  components: {
    VTabs
  },
  props: {
    value: {
      required: false
    }
  },
  computed: {
    sliderSize(): number | string {
      if (this.$attrs['slider-size']) {
        return this.$attrs['slider-size'];
      } else if (this.$attrs['sliderSize']) {
        return this.$attrs['sliderSize'];
      }
      return 3;
    },
    backgroundColor(): string {
      if (this.$attrs['background-color']) {
        return this.$attrs['background-color'];
      } else if (this.$attrs['backgroundColor']) {
        return this.$attrs['backgroundColor'];
      }
      return 'transparent';
    },
    height(): number | string {
      if (this.$attrs['height']) {
        return this.$attrs['height'];
      }
      return 40;
    }
  }
});
